import { ActionService } from 'dashboard-services/services';

export default (() => {
  const SET_SORTING = 'SET_SORTING_COMPANIES_MY_ACCOUNT'
  const setSorting = ActionService.makeActionCreator(SET_SORTING, 'value')

  const ON_CHANGE = 'ON_CHANGE_COMPANIES_MY_ACCOUNT'
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')

  const ON_ADD_COMPANY_MODAL_CHANGE = 'ON_ADD_COMPANY_MODAL_CHANGE'
  const onAddCompanyModalChange =  ActionService.makeActionCreator(ON_ADD_COMPANY_MODAL_CHANGE, 'value')

  return {
    SET_SORTING,
    setSorting,
    onChange,
    ON_CHANGE,
    onAddCompanyModalChange,
    ON_ADD_COMPANY_MODAL_CHANGE
  }
})()